import { useContext } from 'react'
import BootstrapDataContext from '../../context/BootstrapDataContext'

export default function usePrePopFormHeadline() {
  const { prePopData } = useContext(BootstrapDataContext)
  const endLocation = prePopData?.hotels?.endLocation
  const hasCity = !!endLocation?.cityName && endLocation?.type === 'CITY'
  return hasCity ? `Search ${endLocation?.cityName} Hotels` : null
}
